import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import PieChartIcon from '~images/chats-page/pie_chart.svg'
import AutoinformIcon from '~images/chats-page/autoinform.svg'
import PhoneStarIcon from '~images/chats-page/phone_star.svg'
import SmartphoneIcon from '~images/chats-page/smartphone.svg'
import { OnlinepbxButtonLink } from '@onpbx/onlinepbx-components'
import { Link } from 'react-router-dom'

const OtherSolutions = () => {
  return (
    <Screen
      title={<span><StyledScreen.GreenText>Другие</StyledScreen.GreenText> решения</span>}
      bottomLine
      className='other-solutions'
    >
      <div className='other-solutions__container'>
        <Link className='other-solutions__item' to='/features/reports'>
          <div className='other-solutions__icon'>
            <PieChartIcon />
          </div>
          <h3 className='other-solutions__item-title'>Бизнес-аналитика</h3>
          <p className='other-solutions__item-text'>Управляйте продажами на основе цифр</p>
          <OnlinepbxButtonLink href='/features/reports' text='Подробнее' />
        </Link>
        <Link className='other-solutions__item' to='/features/autoinformator'>
          <div className='other-solutions__icon'>
            <AutoinformIcon />
          </div>
          <h3 className='other-solutions__item-title'>Автоинформатор</h3>
          <p className='other-solutions__item-text'>Автоматизация рутинных процессов</p>
          <OnlinepbxButtonLink href='/features/autoinformator' text='Подробнее' />
        </Link>
        <Link className='other-solutions__item' to='/features/quality'>
          <div className='other-solutions__icon'>
            <PhoneStarIcon />
          </div>
          <h3 className='other-solutions__item-title'>Оценка качества</h3>
          <p className='other-solutions__item-text'>Узнайте мнение клиентов о вашем сервисе</p>
          <OnlinepbxButtonLink href='/features/quality' text='Подробнее' />
        </Link>
        <Link className='other-solutions__item' to='/features/calls'>
          <div className='other-solutions__icon'>
            <SmartphoneIcon />
          </div>
          <h3 className='other-solutions__item-title'>Мобильное приложение для звонков</h3>
          <p className='other-solutions__item-text'>Звоните со своего мобильного телефона, все звонки попадут в АТС</p>
          <OnlinepbxButtonLink href='/features/calls' text='Подробнее' />
        </Link>
        <Link className='other-solutions__item' to='/features/admin'>
          <div className='other-solutions__icon'>
            <SmartphoneIcon />
          </div>
          <h3 className='other-solutions__item-title'>Мобильное приложение для админа</h3>
          <p className='other-solutions__item-text'>История звонков, настройки и оплата в вашем телефоне</p>
          <OnlinepbxButtonLink href='/features/admin' text='Подробнее' />
        </Link>
      </div>
    </Screen>
  )
}

export default OtherSolutions;